import { type SxProps } from '@mui/system/styleFunctionSx';
import { useTheme } from '@mui/material';
import { StatusWrapper } from './styles';
import { useTranslation } from 'react-i18next';

export enum IntegrationStatusType {
  ACTIVE = 'active',
  NOT_SUPPORTED = 'not_supported'
}

const useStatusStyles = (): Record<IntegrationStatusType, SxProps> => {
  const theme: any = useTheme();
  return {
    [IntegrationStatusType.ACTIVE]: {
      backgroundColor: theme.palette.success.main,
      color: theme.palette.success.dark
    },
    [IntegrationStatusType.NOT_SUPPORTED]: {
      backgroundColor: theme.palette.gray.superLight,
      color: theme.palette.gray.dark
    }
  };
};

type StatusTagProps = {
  status: IntegrationStatusType;
};

export const StatusTag = ({ status }: StatusTagProps) => {
  const { t } = useTranslation(['settings']);
  const statusStyles = useStatusStyles();
  return <StatusWrapper sx={statusStyles[status]}>{t(`integrations.status.${status}`)}</StatusWrapper>;
};
